var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30762 8.44159C4.30762 6.75322 5.67143 5.38452 7.35377 5.38452C9.03612 5.38452 10.3999 6.75322 10.3999 8.44159C10.3999 10.13 9.03612 11.4987 7.35377 11.4987C5.67143 11.4987 4.30762 10.13 4.30762 8.44159Z",
    fill: "#A6ACB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1692 8.44159C13.1692 7.98113 13.5411 7.60785 13.9999 7.60785L22.8615 7.60785C23.3203 7.60785 23.6922 7.98113 23.6922 8.44159C23.6922 8.90206 23.3203 9.27534 22.8615 9.27534L13.9999 9.27534C13.5411 9.27534 13.1692 8.90206 13.1692 8.44159Z",
    fill: "#A6ACB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6461 16.5011C18.9637 16.5011 17.5999 17.8698 17.5999 19.5582C17.5999 21.2466 18.9637 22.6153 20.6461 22.6153C22.3284 22.6153 23.6922 21.2466 23.6922 19.5582C23.6922 17.8698 22.3284 16.5011 20.6461 16.5011Z",
    fill: "#A6ACB3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30762 19.5582C4.30762 19.0978 4.67957 18.7245 5.13839 18.7245L13.9999 18.7245C14.4587 18.7245 14.8307 19.0978 14.8307 19.5582C14.8307 20.0187 14.4587 20.392 13.9999 20.392L5.13839 20.392C4.67957 20.392 4.30762 20.0187 4.30762 19.5582Z",
    fill: "#A6ACB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.440394d8e647e4f53f020c9eaa15f80a.svg";
export { ForwardRef as ReactComponent };